<template>
  <div>
    <form class="login-container">
      <div class="row">
        <label>User Name</label>
        <input class="form-control" ref="username" v-model="user.username" placeholder=""
               @keyup.enter="login">
      </div>
      <div class="row password">
        <label>Password</label>
        <input class="form-control" :type="inputType" v-model="user.password"
               placeholder=""
               @keyup.enter="login">
        <div class="show-password-container" @click="toggleVisiblePassword">
          <icon name="eye" v-show="!showPassword"></icon>
          <icon name="eye-slash" v-show="showPassword"></icon>
        </div>
      </div>
      <div class="login-btn-wrapper">
        <b-btn class="login-btn btn-lg col-sm-5" @click="login">Login</b-btn>
      </div>
    </form>
    <div class="text-center">
      <small>{{$t('labels.common.contact_details')}}</small>
      <small><a target="_blank" :href="SERVICE_DESK_URL">Service Desk</a></small>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { setToken, handlerResponse } from '@/helpers/commonHelpers'
  import { SERVICE_DESK_URL } from '@/constants'

  export default {
    data() {
      return {
        SERVICE_DESK_URL,
        user: {
          username: '',
          password: '',
        },
        showPassword: false
      }
    },
    methods: {
      login() {
        if (this.user.username !== '' && this.user.password !== '') {
          this.$http.post('authtoken/', this.user)
            .then(handlerResponse)
            .then(async (data) => {
              setToken(data.token);
              this.$store.dispatch('login/updateUserName', this.user);
              this.$store.commit('login/setUserRoles', data.user);
              localStorage.setItem('login', true);
              localStorage.setItem('token', data.token);
              localStorage.setItem('userRoles', data.user);
              await this.$store.dispatch('generic/loadUserPermissions');
              this.$store.commit('menu/setVisibleMenuItems', this.permissionsList);
              await this.$router.push('/');
            }).catch(() => {
            this.$swal.fire('', 'Incorrect email or password', 'error');
          });
        }
      },
      toggleVisiblePassword() {
        this.showPassword = !this.showPassword;
      }
    },
    mounted() {
      this.$refs['username'].focus();
    },
    computed: {
      ...mapGetters('generic', {
        permissionsList: 'permissionsList'
      }),
      inputType() {
        return this.showPassword ? 'text' : 'password'
      }
    }
  }
</script>

<style scoped lang="scss">

  .password {
    position: relative;

    .show-password-container {
      cursor: pointer;
      position: absolute;
      bottom: 4px;
      right: 7px;

      > .fa-icon {
        height: 22px;
        width: 22px;
        color: #7d7d7d;

        &:hover {
          color: #4e4c4c;
        }
      }
    }
  }

  .login-container {
    border: 1px solid #cac1c1;
    margin-top: 30vh;
    padding: 50px;
    border-radius: 10px;
    background: #38486a;
    box-shadow: 5px 5px 5px 0 rgba(158, 152, 158, 0.75);
  }

  .login-container label {
    color: #fff;
  }

  .login-btn-wrapper {
    margin-top: 25px;
    text-align: center;
  }

  .login-btn {
    background: #c8c4c5;
    color: #38486a;
    font-weight: 700;
    font-size: 14px;
    height: auto;
    padding: 10px;
    border-radius: 7px;
    text-transform: uppercase;
  }

  .login-btn-wrapper .login-btn:active {
    background: #c8c4c5;
    color: #38486a;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue